import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { BundleRow } from "../models/types";

const moment = getMomentTz();

export const getBundlesData = async (
	start: Date | null,
	end: Date | null,
): Promise<BundleRow[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: start ? start.toISOString() : null },
		{ name: "End", value: end ? end.toISOString() : null },
	];

	const resp = await apiService.callV2(
		"[FAB].[GetBundlesProduction]",
		parameters,
	);
	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []).map(
			(row: Record<string, unknown>) => ({
				...row,
				StartTime: row.StartTime ? moment.utc(row.StartTime).toDate() : null,
				EndTime: row.EndTime ? moment.utc(row.EndTime).toDate() : null,
			}),
		) as BundleRow[];
		return rows;
	}
	throw new Error(resp.message || "Error fetching bundles data");
};
